<template>
  <div class="sy-nav">
    <van-nav-bar class="title" :title="$t('routerBase.'+$route.meta.title)" left-arrow fixed @click-left="onClickLeft" />
    <div class="content">
      <img :src="url">
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      url: require('@/assets/images/setting/doc.png')
    }
  },
  created() {
    this.initFun()
  },
  methods: {
    initFun: function() {
      var lan = Cookies.get('language')
      if (lan === 'en') {
        this.url = require('@/assets/images/setting/doc-en.png')
      }
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
      //   Toast('返回')
    }
  }
}
</script>

<style scoped lang="scss">
  .sy-nav {
    height: 100vh;
    background: white;
  }
  .title{
    box-shadow:0px 3px 4px 0px rgba(190,190,190,0.3);
  }
  .content {
    background-color: white;
    img{
      width: 100%;
    }
  }
  /deep/.van-nav-bar .van-icon {
    color: #F18937;
    vertical-align: middle;
  }
</style>

